module.exports = __webpack_public_path__ + "static/media/pinterest.453dd060.png";